import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import TextFieldComponent from "../../../../../components/TextField/TextFieldComponent";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import LabelComponent from "../../../../../components/Label/LabelComponent";
import { CatalogoCategoria, ItemCategoria } from "../../../../../interface/item/categoria/ItemCategoria";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import CheckboxComponent from "../../../../../components/checkbox/CheckboxComponent";

interface ModalComplementoProps {
    open: boolean;
    onClose: () => void;

    tab: number;
    onChangeTab: (tab: number) => void;

    onSubmit: (categoria: CatalogoCategoria) => void;
}

const buttonStyle = {
    width: '119px',
    height: '42px',
    padding: '8px 24px',
    borderRadius: '8px',
    opacity: 1,
    minWidth: 'auto',

    border: '1px solid var(--color-orange-87, #E8DFD5)',

    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none',

    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    boxSizing: 'border-box',

    // // Efeito de hover básico para o botão não parecer estático
    // '&:hover': {
    //     backgroundColor: 'rgba(232, 223, 213, 0.08)', // Um leve reflexo no tom da borda
    //     border: '1px solid var(--color-orange-87, #E8DFD5)',
    // }
}

const labelStyle = {
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
}

const inputStyle = {
    //width: '400px',
    height: '42px',
    opacity: 1,

    // Customização da borda e inputs internos do MUI
    '& .MuiOutlinedInput-root': {
        height: '42px',
        padding: '8px 16px', // Alinha com seu padding de design
        borderRadius: '8px',

        // Cor da borda em repouso
        '& fieldset': {
            border: '1px solid var(--color-orange-87, #E8DFD5)',
        },
        // Cor da borda ao passar o mouse (hover)
        '&:hover fieldset': {
            borderColor: '#FF8C42', // Usando aquele laranja padrão de ontem para o hover, ajuste se preferir!
        },
        // Cor da borda quando estiver focado (clicado)
        '&.Mui-focused fieldset': {
            borderColor: '#FF8C42',
            borderWidth: '1.5px', // Destaca o foco de forma suave
        },
    },
    // Ajuste do espaçamento interno do texto digitado para caber nos 42px de altura
    '& .MuiInputBase-input': {
        padding: 0,
        boxSizing: 'border-box',
    }
};

const ModalCategoria = (props: ModalComplementoProps) => {
    const [categoria, setCategoria] = useState<CatalogoCategoria>({
        id: undefined,
        nome: "",
        descricao: "",
        ativo: true
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // if (!formData) return;    
        props.onSubmit(categoria);
    };

    const handleChangeCategoria = (label: string, value: string | boolean) => {
        if (!categoria) return;

        setCategoria({
            ...categoria,
            [label]: value
        });
    }

    return <Dialog
        open={props.open}
        onClose={props.onClose}
        PaperProps={{
            component: "form",
            onSubmit: handleSubmit,
            sx: {
                width: "630px",
                maxWidth: "calc(100vw - 32px)"
            }
        }}
    >
        <DialogTitle
            sx={{
                fontFamily: '"Font 7", sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '32px',
                letterSpacing: '0%',
                color: '#2C2C2C',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
            }}
        >
            Informações da nova categoria
        </DialogTitle>

        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Tabs
                value={props.tab}
                onChange={(_, newValue) => props.onChangeTab(newValue)}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    "& .MuiTab-root": {
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0%',
                        textAlign: 'center',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        verticalAlign: 'middle',
                        textTransform: "inherit",
                        color: "#9e9e9e",
                    },
                    "& .Mui-selected": {
                        color: "#F57C00 !important",
                    },
                    "& .MuiTabs-indicator": {
                        backgroundColor: "#F57C00",
                        height: 3,
                    },
                }}
            >
                <Tab label="Informações" />
                <Tab label="Disponibilidade" />
            </Tabs>

            {props.tab === 0 && (
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                    <BoxComponent component="div">
                        <LabelComponent htmlFor="nome" sx={labelStyle}>
                            Nome da categoria *
                        </LabelComponent>
                        <TextFieldComponent
                            id="nome"
                            placeholder="Ex: Bacon Extra, Queijo Adicional..."
                            variant="outlined"
                            value={categoria?.nome ?? ""}
                            onChange={(e) => handleChangeCategoria("nome", e.target.value)}
                            fullWidth
                            sx={inputStyle}
                            required
                        />
                    </BoxComponent>

                    <BoxComponent component="div">
                        <LabelComponent htmlFor="descricao" sx={labelStyle}>
                            Descrição da categoria *
                        </LabelComponent>
                        <TextFieldComponent
                            id="descricao"
                            placeholder="Descreva a categoria..."
                            variant="outlined"
                            multiline
                            rows={4}
                            value={categoria?.descricao ?? ""}
                            onChange={(e) => handleChangeCategoria("descricao", e.target.value)}
                            fullWidth
                            sx={{
                                ...inputStyle,
                                height: "auto",
                                '& .MuiOutlinedInput-root': {
                                    height: 'auto',
                                }
                            }}
                            required
                        />
                    </BoxComponent>
                </BoxComponent>
            )}

            {props.tab === 1 && (
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: 'var(--color-grey-60, #999999)',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        Defina a disponibilidade desta categoria:
                    </TypographyComponent>

                    <BoxComponent component="fieldset"
                        sx={{
                            backgroundColor: '#F8F5F0',
                            border: '1px solid var(--color-orange-87, #E8DFD5)',
                            borderRadius: '8px',
                            padding: '16px',
                            opacity: 1,

                            // Alinhamento Flexbox (com o espaço distribuído nas pontas)
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center', // Alinha verticalmente ao centro
                            // gap: '357.5px',
                            boxSizing: 'border-box'
                        }}
                    >
                        <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1, flex: 1 }}>
                            <LabelComponent htmlFor="ativo"
                                sx={{
                                    fontFamily: '"Font 7", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0%',
                                    color: 'var(--color-grey-17, #2C2C2C)',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                            >
                                Ativo
                            </LabelComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 7", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0%',
                                    color: 'var(--color-grey-60, #999999)',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                            >
                                A categoria estará visível no catálogo
                            </TypographyComponent>
                        </BoxComponent>
                        <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <CheckboxComponent
                                id="ativo"
                                checked={categoria?.ativo ?? false}
                                onChange={(checked) => handleChangeCategoria("ativo", checked)}
                            />
                        </BoxComponent>
                    </BoxComponent>

                    <Alert severity="error">
                        Dica: Categorias inativas não aparecem no catálogo, mas os produtos continuam salvos.
                    </Alert>
                </BoxComponent>
            )}

        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>

            <ButtonComponent
                id="cancelar-categoria"
                variant="outlined"
                type="button"
                sx={{ ...buttonStyle, color: '#2C2C2C' }}
                onClick={props.onClose}
            >
                Cancelar
            </ButtonComponent>

            <ButtonComponent
                id="salvar-categoria"
                type="submit"
                variant="outlined"
                sx={{ ...buttonStyle, backgroundColor: "#FF8C42", color: '#FFFFFF' }}
            >
                Salvar
            </ButtonComponent>

        </DialogActions>
    </Dialog>
}

export default ModalCategoria;